import type { Dex, Pool } from "@auto-pools/core/contracts";

/** The display name of a pool's DEX; `dex` absent means Orca, as on every contract. */
export function dexName(dex: Dex | undefined) {
  return dex === "raydium" ? "Raydium" : "Orca";
}

/**
 * The DEX's own page for the pool. Raydium has no read-only CLMM pool page; its pool list links each
 * concentrated pool to this position page, which shows the pool and opens nothing by itself.
 */
export function dexPoolUrl(dex: Dex | undefined, address: string) {
  return dex === "raydium"
    ? `https://raydium.io/clmm/create-position/?pool_id=${address}`
    : `https://www.orca.so/pools/${address}`;
}

/** Why a manual open is refused for this pool, or null when the catalog offers it. */
export function openableReason(pool: Pick<Pool, "openable">) {
  if (pool.openable?.ok !== false) return null;
  return pool.openable.reason ?? "Opening is not offered for this pool";
}
